import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { PrivateLessonsComponent } from './components/private-lessons/private-lessons.component';
import { TeamComponent } from './components/team/team.component';
import { ClassesComponent } from './components/classes/classes.component';
import { BoxingComponent } from './components/boxing/boxing.component';
import { MuayThaiComponent } from './components/muay-thai/muay-thai.component';
import { TaekwondoComponent } from './components/taekwondo/taekwondo.component';
import { EscrimaKaliComponent } from './components/escrima-kali/escrima-kali.component';
import { KidsClassesComponent } from './components/kids-classes/kids-classes.component';
import { SparringComponent } from './components/sparring/sparring.component';
import { CardioKickboxingComponent } from './components/cardio-kickboxing/cardio-kickboxing.component';
import { BrazilianJiuJitsuComponent } from './components/brazilian-jiu-jitsu/brazilian-jiu-jitsu.component';

const APP_ROUTES: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'classes', component: ClassesComponent },
	{ path: 'schedule', component: ScheduleComponent },
	{ path: 'private-lessons', component: PrivateLessonsComponent },
	{ path: 'team', component: TeamComponent },
	{ path: 'classes/boxing', component: BoxingComponent },
	{ path: 'classes/muay-thai', component: MuayThaiComponent },
	{ path: 'classes/taekwondo', component: TaekwondoComponent },
	{ path: 'classes/escrima-kali', component: EscrimaKaliComponent },
	{ path: 'classes/kids-classes', component: KidsClassesComponent },
	{ path: 'classes/sparring', component: SparringComponent },
	{ path: 'classes/cardio-kickboxing', component: CardioKickboxingComponent },
	{ path: 'classes/brazilian-jiu-jitsu', component: BrazilianJiuJitsuComponent },
	{ path: '**', redirectTo: '' }
];

@NgModule({
	imports: [RouterModule.forRoot(APP_ROUTES, { scrollPositionRestoration: 'enabled' })], 
	exports: [RouterModule]
})

export class AppRoutingModule { }

